import { atomWithStorage } from "jotai/utils";
import Cookies from "js-cookie";
import { UserOperatingContextDTO } from "../datasources/api-client/data-contracts";
import { cookieStorage, StorageKeys } from "./storage";

/**
 * Holds the user JWT token.
 */
export const currentAuthenticationToken = atomWithStorage<string | undefined>(
	StorageKeys.JwtToken,
	undefined,
	cookieStorage
);

/**
 * getCurrentAuthenticationToken is a utility function that is used to access user
 * JWT token in read-only mode without the need to use atoms.
 *
 * This is helpful in all contexts where hooks like useAtom are not supported.
 *
 * @returns user current JWT4
 */
export const getCurrentAuthenticationToken = (): string | undefined => Cookies.get(StorageKeys.JwtToken);

/**
 * Returns the current user data by reading the local storage.
 */
export const getCurrentUserData = (): UserOperatingContextDTO | undefined => {
	const raw = localStorage.getItem(StorageKeys.UserData);
	return raw ? JSON.parse(raw) : undefined;
};

/**
 * Holds the user JTW data.
 */
export const currentUser = atomWithStorage<UserOperatingContextDTO | undefined>(StorageKeys.UserData, undefined, {
	getItem(key) {
		const storedValue = localStorage.getItem(key);
		if (!storedValue) {
			return undefined;
		}

		try {
			return JSON.parse(storedValue) as UserOperatingContextDTO;
		} catch {
			console.warn("cannot parse user company and permissions stored in the local storage");
			return undefined;
		}
	},
	setItem(key, newValue) {
		if (!newValue) {
			localStorage.removeItem(key);
		} else {
			localStorage.setItem(key, JSON.stringify(newValue));
		}
	},
	removeItem(key) {
		localStorage.removeItem(key);
	},
});
